import { c as _c } from "react/compiler-runtime";
import styled from 'styled-components';
import { StyledCard } from '../../../../common/base/Card';
import Icon, { IconName } from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
const StyledTypeContainer = styled(StyledCard)`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({
  theme
}) => theme.spacing(1.5)} ${({
  theme
}) => theme.spacing(3)};
  background-color: ${({
  theme
}) => theme.colors.surface.base.variant_surface_2};
`;
export const PreviewTypeContainer = t0 => {
  const $ = _c(10);
  const {
    icon,
    label,
    authenticated
  } = t0;
  const t1 = icon as IconName;
  let t2;
  if ($[0] !== t1) {
    t2 = <Icon icon={t1} left={true} small={true} muted={true} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <Text w={100} cursor_default={true}>{label}</Text>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== authenticated) {
    t4 = authenticated && <Tooltip side="bottom" tooltip="Authenticated"><Icon muted={true} icon="verification" right={true} /></Tooltip>;
    $[4] = authenticated;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <StyledTypeContainer>{t2}{t3}{t4}</StyledTypeContainer>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};